module.exports = __webpack_public_path__ + "img/uncontact1.e7dfa0d2.png";